import { css } from 'styled-components';
export var borderSize = function borderSize(props) {
  return props.theme.border === 'thick' ? '2px' : '1px';
};
export var border = function border(theme, color) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$thin = _ref.thin,
      thin = _ref$thin === void 0 ? 1 : _ref$thin,
      _ref$thick = _ref.thick,
      thick = _ref$thick === void 0 ? 2 : _ref$thick;

  var thickness = theme.border === 'thick' ? thick : thin;
  return "".concat(thickness, "px solid ").concat(theme.colors[color] || color);
};
export var insetBorder = function insetBorder(theme, color, direction) {
  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref2$thin = _ref2.thin,
      thin = _ref2$thin === void 0 ? 1 : _ref2$thin,
      _ref2$thick = _ref2.thick,
      thick = _ref2$thick === void 0 ? 2 : _ref2$thick;

  var hOffset = 0,
      vOffset = 0,
      spread = 0;
  var thickness = theme.border === 'thick' ? thick : thin;

  if (direction === 'top') {
    vOffset = thickness;
  } else if (direction === 'bottom') {
    vOffset = -thickness;
  } else if (direction === 'left') {
    hOffset = thickness;
  } else if (direction === 'right') {
    hOffset = -thickness;
  } else {
    spread = thickness;
  }

  color = theme.colors[color] || color;
  return "box-shadow: inset ".concat(hOffset, "px ").concat(vOffset, "px 0 ").concat(spread, "px ").concat(color);
};
var radiiMap = {
  8: {
    square: '1px',
    intermediate: '4px',
    round: '8px'
  },
  20: {
    square: '1px',
    intermediate: '8px',
    round: '20px'
  }
};
export var radius = function radius(maxRadius) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return radiiMap[maxRadius][theme.shape];
  };
};
var popupShapeMap = {
  dialog: {
    square: css(["border-radius:0 2px 1px 1px;"]),
    intermediate: css(["border-radius:0 20px 10px 10px;"]),
    round: css(["border-radius:0 32px 16px 16px;"])
  },
  menu: {
    square: css(["border-radius:0 0 1px 1px;"]),
    intermediate: css(["border-radius:0 0 4px 4px;"]),
    round: css(["border-radius:0 0 8px 8px;"])
  }
};
export var popupShape = function popupShape(popupType, shape) {
  return popupShapeMap[popupType][shape];
};
export var popupBoxShadow = function popupBoxShadow(theme) {
  return theme.boxShadows ? css(["", ";"], boxShadow(theme, 1)) : css(["border:", " solid;border-color:", ";"], function (p) {
    return borderSize(p);
  }, theme.colors.lightContrast);
};
export var invertColors = function invertColors(style) {
  return {
    color: style.backgroundColor,
    backgroundColor: style.color
  };
};
export var shadowTypes = ['0 0 3px', '0 3px 8px', '0 9px 24px', '0 12px 24px', '0 30px 42px', '0 45px 48px'];
export var boxShadow = function boxShadow(theme, shadowType) {
  if (theme.boxShadows) {
    if (typeof shadowType === 'number') {
      shadowType = shadowTypes[shadowType];
    }

    return "box-shadow: ".concat(shadowType, " ").concat(theme.colors.lightCallToAction);
  } else {
    return '';
  }
};
export var fontSize = function fontSize(theme, size) {
  if (theme.mediaQueries) {
    return "\n      font-size: ".concat(theme.mobileFontSizes[size], "px;\n      ").concat(theme.mediaQueries.medium, " {\n        font-size: ").concat(theme.fontSizes[size], "px;\n      }\n    ");
  }

  return "font-size: ".concat(theme.fontSizes[size], "px;");
};
export var textStyle = function textStyle(theme, size) {
  if (theme.mediaQueries) {
    return css(["", " ", "{", "}"], theme.mobileTextStyles[size], theme.mediaQueries.medium, theme.textStyles[size]);
  }

  return theme.textStyles[size];
};
export var media = function media(theme, query) {
  return theme.mediaQueries && theme.mediaQueries[query];
};
/* Detects if the user is using a mobile/touch device which falls under either the SMALL or TINY breakpoint
category AND that the site they are on is optimized for a device of that size */

export var isResponsiveTouchDevice = function isResponsiveTouchDevice(breakpoints) {
  return typeof window !== 'undefined' && typeof screen !== 'undefined' && window.innerWidth < Number(breakpoints[0].split('px')[0]) && 'ontouchstart' in window && screen.width === window.innerWidth;
};